/**
 * @generated SignedSource<<ea435e020e752156e8aaa9618341cd9c>>
 * @relayHash bd4580f0053e11ae636049ae3c53b81c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3b089ddec155bf88dc83de4288cc5473c2c1929d6f169e0b96946e0d58c7f256

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GrowthUnifiedProfileProductEdition = "ENTERPRISE" | "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
export type freeChooseYourEditionModalQuery$variables = {
  cloudId: string;
  hamsProductKey: string;
};
export type freeChooseYourEditionModalQuery$data = {
  readonly confluence_storage: {
    readonly bytesLimit: AGG$Long | null | undefined;
    readonly bytesUsed: AGG$Long;
    readonly isUnlimited: boolean | null | undefined;
  } | null | undefined;
  readonly growthUnifiedProfile_getUnifiedProfile: {
    readonly sites: ReadonlyArray<{
      readonly products: ReadonlyArray<{
        readonly nbeRecommendation: {
          readonly edition: GrowthUnifiedProfileProductEdition | null | undefined;
          readonly recommendationDate: string | null | undefined;
        } | null | undefined;
        readonly productName: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement?: {
        readonly experienceCapabilities: {
          readonly changeOfferingPremium: {
            readonly experienceUrl: string | null | undefined;
          } | null | undefined;
          readonly compareOfferingsPremiumHighlighted: {
            readonly experienceUrl: string | null | undefined;
          } | null | undefined;
          readonly compareOfferingsStandardHighlighted: {
            readonly experienceUrl: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type freeChooseYourEditionModalQuery = {
  response: freeChooseYourEditionModalQuery$data;
  variables: freeChooseYourEditionModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hamsProductKey"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v3 = [
  {
    "kind": "ScalarField",
    "name": "experienceUrl"
  }
],
v4 = {
  "concreteType": "CcpEntitlementExperienceCapabilities",
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "alias": "changeOfferingPremium",
      "args": [
        {
          "kind": "Literal",
          "name": "offeringName",
          "value": "Premium"
        }
      ],
      "concreteType": "CcpChangeOfferingExperienceCapability",
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
    },
    {
      "alias": "compareOfferingsStandardHighlighted",
      "args": [
        {
          "kind": "Literal",
          "name": "input",
          "value": {
            "highlightedOffering": {
              "offeringName": "Standard"
            }
          }
        }
      ],
      "concreteType": "CcpCompareOfferingsExperienceCapability",
      "kind": "LinkedField",
      "name": "compareOfferings",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": "compareOfferings(input:{\"highlightedOffering\":{\"offeringName\":\"Standard\"}})"
    },
    {
      "alias": "compareOfferingsPremiumHighlighted",
      "args": [
        {
          "kind": "Literal",
          "name": "input",
          "value": {
            "highlightedOffering": {
              "offeringName": "Premium"
            }
          }
        }
      ],
      "concreteType": "CcpCompareOfferingsExperienceCapability",
      "kind": "LinkedField",
      "name": "compareOfferings",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": "compareOfferings(input:{\"highlightedOffering\":{\"offeringName\":\"Premium\"}})"
    }
  ]
},
v5 = {
  "concreteType": "ConfluenceStorage",
  "kind": "LinkedField",
  "name": "confluence_storage",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isUnlimited"
    },
    {
      "kind": "ScalarField",
      "name": "bytesUsed"
    },
    {
      "kind": "ScalarField",
      "name": "bytesLimit"
    }
  ]
},
v6 = {
  "args": [
    {
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "cloudId"
    }
  ],
  "concreteType": "GrowthUnifiedProfileResult",
  "kind": "LinkedField",
  "name": "growthUnifiedProfile_getUnifiedProfile",
  "plural": false,
  "selections": [
    {
      "concreteType": "GrowthUnifiedProfileSiteDetails",
      "kind": "LinkedField",
      "name": "sites",
      "plural": true,
      "selections": [
        {
          "concreteType": "GrowthUnifiedProfileProductDetails",
          "kind": "LinkedField",
          "name": "products",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "productName"
            },
            {
              "concreteType": "GrowthUnifiedProfileProductNBE",
              "kind": "LinkedField",
              "name": "nbeRecommendation",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "edition"
                },
                {
                  "kind": "ScalarField",
                  "name": "recommendationDate"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "freeChooseYourEditionModalQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ]
          }
        ]
      },
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "freeChooseYourEditionModalQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ]
          }
        ]
      },
      (v5/*: any*/),
      (v6/*: any*/)
    ]
  },
  "params": {
    "id": "3b089ddec155bf88dc83de4288cc5473c2c1929d6f169e0b96946e0d58c7f256",
    "metadata": {},
    "name": "freeChooseYourEditionModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0e8059c3834ad6cb88d2ac63ac9691cb";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
